// extracted by mini-css-extract-plugin
module.exports = {"component":"State_component__3ppVo","icon":"State_icon__3JZdG","content":"State_content__13RpK"};